<template>
    <div id="productAddModal" class="modal fade add-customer-popup">
        <div class="modal-dialog modal-confirm  modal-dialog-centered modal-xl modal-dialog-scrollable"
             style="max-width: 500px !important;">
            <div class="modal-content">
                <div class="modal-header bg-soft-info p-3">
                    <h5 class="modal-title">Create Product</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i
                        class="ri-close-line"></i></button>
                </div>
                <div class="modal-body" v-if="show">
                    <div class="">

                        <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                            <strong class="success_msg">{{ successMessage }}</strong>
                        </div>
                        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                            <ul>
                                <li v-for="(v, k) in commonErrors" :key="k">
                                    <p v-for="error in v" :key="error" class="text-sm">
                                        {{ error }}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm"
                                  method="post">
                                <div class="new-rfq">
                                    <div class="row">

                                        <div class="col-lg-12 col-md-12">
                                            <div class="">

                                                <div class="">

                                                    <!-- <h2 class="mb-3 inner-title">Company Information</h2> -->
                                                    <div class="">
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6">
                                                                <div class="form-group flex-fill">
                                                                    <label>Product Number</label>
                                                                    <validation-provider rules="required"
                                                                                         v-slot="{ errors }">
                                                                        <input type="text" class="form-control"
                                                                               placeholder="" name="product_num"
                                                                               id="product_num"
                                                                               v-model="form.product_num"/>
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6">
                                                                <div class="form-group flex-fill">
                                                                    <label>Customer SKU</label>
                                                                    <input type="text" class="form-control"  placeholder="" name="customer_sku" id="customer_sku" v-model="form.customer_sku" />
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-12 col-md-12">
                                                                <div class="form-group flex-fill">
                                                                    <label>Product Name</label>
                                                                    <input type="text" class="form-control"
                                                                           name="company_name" placeholder=""
                                                                           v-model="form.product_name">
                                                                </div>
                                                            </div>
                                                            
                                                            
                                                        </div>
                                                        <div class="form-group flex-fill">
                                                            <label>Product Description</label>
                                                            <!--<ckeditor v-model="form.product_desc" :config="ckEditorMinConfig()"></ckeditor>-->
                                                            <VueEditor ref="product_desc_123" id="product_desc_123"
                                                                       @focus="editorFocus" v-model="form.product_desc"
                                                                       :editorToolbar="getXSmallQuillToolbar()"></VueEditor>

                                                        </div>
                                                        <div class="row">
                                                            <!--<div class="col-lg-6 col-md-6">
                                                                <div class="form-group flex-fill">
                                                                    <label>Product Price</label>
                                                                    <validation-provider rules="required|positive" v-slot="{ errors }">
                                                                    <input type="text"  class="form-control" name="address" placeholder="Product Price" v-model="form.price">
                                                                    <span class="error-message">{{ errors[0] }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>-->
                                                            
                                                            <div class="col-lg-4 col-md-4">
                                                                <div class="form-group flex-fill">
                                                                    <label>Selling Price</label>
                                                                    <validation-provider rules="required|positive"
                                                                                         v-slot="{ errors }">
                                                                        <input type="text" class="form-control"
                                                                               name="address" placeholder=""
                                                                               v-model="form.selling">
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-8 col-md-8">

                                                                <div class="form-group flex-fill">
                                                                    <label>Customer</label>
                                                                    <validation-provider rules="required"
                                                                                         v-slot="{ errors }">
                                                                        <v-select placeholder="Search Customer"
                                                                                  label="company_name"
                                                                                  v-model="form.customer_id"
                                                                                  :filterable="false"
                                                                                  :options="optionsCustomer"
                                                                                  :reduce="(optionc) => optionc.id"
                                                                                  @search="onCustomerSearch">
                                                                            <template slot="no-options">
                                                                                Search Customer
                                                                            </template>
                                                                            <template slot="option"
                                                                                      slot-scope="optionc">
                                                                                <div class="d-center">
                                                                                    {{ optionc.company_name }}
                                                                                </div>
                                                                            </template>
                                                                            <template slot="selected-option"
                                                                                      slot-scope="optionc">
                                                                                <div class="selected d-center">
                                                                                    {{ optionc.company_name }}
                                                                                </div>
                                                                            </template>
                                                                        </v-select>
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>

                                                                </div>
                                                            </div>

                                                            

                                                            <div class="col-lg-4 col-md-4">
                                                                <div class="form-group flex-fill">
                                                                    <label>Vendor Price</label>
                                                                    <validation-provider rules="required|positive"
                                                                                         v-slot="{ errors }">
                                                                        <input type="text" class="form-control"
                                                                               name="vendor_cost" placeholder=""
                                                                               v-model="form.vendor_cost">
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-8 col-md-8">
                                                                <div class="form-group flex-fill">
                                                                    <label>Vendor</label>
                                                                    <validation-provider rules="required"
                                                                                         v-slot="{ errors }">
                                                                        <v-select placeholder="Search Vendor"
                                                                                  label="company_name"
                                                                                  v-model="form.vendor_id"
                                                                                  :filterable="false" :options="options"
                                                                                  :reduce="(option) => option.id"
                                                                                  @search="onSearch">
                                                                            <template slot="no-options">
                                                                                Search Vendor
                                                                            </template>
                                                                            <template slot="option" slot-scope="option">
                                                                                <div class="d-center">
                                                                                    {{ option.company_name }}
                                                                                </div>
                                                                            </template>
                                                                            <template slot="selected-option"
                                                                                      slot-scope="option">
                                                                                <div class="selected d-center">
                                                                                    {{ option.company_name }}
                                                                                </div>
                                                                            </template>
                                                                        </v-select>
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>

                                                                </div>
                                                            </div>
                                                            

                                                            <div class="col-lg-4 col-md-4">

                                                                <div class="form-group flex-fill">
                                                                    <label for="status" class="">UOM </label>
                                                                    <validation-provider rules="required"
                                                                                         v-slot="{ errors }">
                                                                        <select
                                                                            class="form-control mdl-textfield__input"
                                                                            id="uom" name="status"
                                                                            v-model="form.qty_unit_id">
                                                                            <template v-for="(quantityUnit,index) in quantityUnits">
                                                                                <option :value="quantityUnit.id">{{ quantityUnit.name }}</option>
                                                                            </template>
                                                                            
                                                                            
                                                                            <!-- <option value="0">InActive</option> -->
                                                                        </select>
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-4 col-md-4">

                                                                <div class="form-group flex-fill">
                                                                    <label for="status" class="">Status </label>
                                                                    <validation-provider rules="required"
                                                                                         v-slot="{ errors }">
                                                                        <select
                                                                            class="form-control mdl-textfield__input"
                                                                            id="status" name="status"
                                                                            v-model="form.status">
                                                                            <option value="1">Active</option>
                                                                            <option value="0">InActive</option>
                                                                        </select>
                                                                        <span class="error-message">{{
                                                                                errors[0]
                                                                            }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-4 col-md-4">
                                                                <div class="form-group flex-fill">
                                                                    <label>Old SKU</label>
                                                                    <input type="text" class="form-control"  placeholder="" name="sku" id="sku" v-model="form.sku" />
                                                                </div>
                                                            </div>
                                                            
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                            <div class="btnrow text-right">
                                                <button type="button" class="btn btn-danger me-1" data-dismiss="modal"
                                                        aria-hidden="true">Discard
                                                </button>
                                                <button type="submit" :disabled="buttonDisable" class="btn btn-primary"
                                                        id="save_customer_btn">Save
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </form>
                        </ValidationObserver>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import {VueEditor} from "vue2-editor";

extend('required', {
    ...required,
    message: 'This field is required'
});
extend('positive', value => {

    if (value >= 0) {
        return true;
    }
    return 'Please enter only number';
});
export default {
    name: "ProductAddModal",
    components: {
        ValidationProvider, ValidationObserver, VueEditor
    },
    created() {
        // this.getCountries();
        
        this.setSuccessMessage(null);
    },
    mounted() {
        this.getQuantityUnits();
        $("#productAddModal").on('show.bs.modal', () => {
            this.show = true;
            /*if (this.$refs.product_desc_123 && this.$refs.product_desc_123.$el.children) {
                console.log(this.$refs.product_desc_123.$el.children[0]);
            }*/
        });

        $('#addTaskModal').on('hidden.bs.modal', function () {
            this.show = false;
        });
    },
    data() {
        return {
            quantityUnits:[],
            show: false,
            editorConfig: {
                // The configuration of the editor.
                toolbar: [
                    ['Font', 'FontSize', '|', 'Bold', 'Italic', 'Underline', 'Styles', '|', 'Format',],
                ],
                //ui: { top: 10, right: 10, bottom: 10, left: 10},
                removePlugins: 'elementspath',
                line_height: "1px;1.1px;1.2px;1.3px;1.4px;1.5px",
            },
            countries: [],
            options: [],
            optionsCustomer: [],
            buttonDisable: false,
            form: {
                product_name: null,
                price: 0,
                product_desc: null,
                product_num: null,
                vendor_id: null,
                selling: null,
                status: "1",
                vendor_cost: null,
                sku: null,
                customer_sku: null,
                qty_unit_id:null
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        getQuantityUnits() {
            let self = this;
            //this.setLoading(true);
            //this.setCommonErrors([]);
            //this.setErrorMessage(null);
            return axios
                .get(window.route("so-quantity-units.index"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    //self.setLoading(false);
                });
        },
        editorFocus(event) {
            //console.log(event)
        },
        save() {
            this.buttonDisable = true;
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('products.store'), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        this.buttonDisable = false;
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        this.buttonDisable = false;
                        self.setErrorMessage(data.errorMessage);
                    } else {


                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            this.buttonDisable = false;
                            self.setSuccessMessage(null);
                            $('#productAddModal').modal('hide');
                            this.form = {
                                product_name: '',
                                price: 0,
                                product_desc: '',
                                product_num: '',
                                vendor_id: '',
                                selling: '',
                                vendor_cost: null,
                                sku: null,
                                customer_sku: null,
                            }
                            requestAnimationFrame(() => {
                                this.$refs.observer.reset();
                            });
                            data.data.price = data.data.selling;
                            self.$emit('productDataSaved', data);
                            //self.$router.push({ name: 'viewProducts' });
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);
                    this.buttonDisable = false;
                });
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        onCustomerSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.customerSearch(loading, search, this);
            }
        },
        customerSearch(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.search', {search: search}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    //console.log("DATA ", data);
                    if (data.errors) {
                        //console.log("error ", data);
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        let customer = [];
                        let allData = data.data.data
                        //console.log("Custumer", data.data.data);
                        vm.optionsCustomer = data.data.data;

                        loading(false);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.search', {search: search}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    //console.log("DATA ", data);
                    if (data.errors) {
                        //console.log("error ", data);
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        let customer = [];
                        let allData = data.data.data
                        //console.log("Vendor", data.data.data);
                        vm.options = data.data.data;

                        loading(false);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
